/**
 * VisualizerContext - Manages 3D visualizer state
 * 
 * Handles:
 * - Visualizer instance
 * - Server availability status
 */
import { createContext, useContext, useState } from 'react';

const VisualizerContext = createContext(null);

export const useVisualizer = () => {
  const context = useContext(VisualizerContext);
  if (!context) {
    throw new Error('useVisualizer must be used within VisualizerProvider');
  }
  return context;
};

export const VisualizerProvider = ({ children }) => {
  const [visualizer, setVisualizer] = useState(null);
  const [isServerAvailable, setIsServerAvailable] = useState(false);

  const value = {
    visualizer,
    setVisualizer,
    isServerAvailable,
    setIsServerAvailable,
  };

  return <VisualizerContext.Provider value={value}>{children}</VisualizerContext.Provider>;
};
